import React, { useState, useEffect } from 'react';

import { Select } from '~/componentes/CustomForm';
import { Container, ThisCard, ThisCalendar, ScrollOS } from './styles';

function CustomBodyContent({ quantRejeitada, osRejeitada, data, anos, anoAtivo, setAnoAtivo }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);
  const [mesAtivo, setMesAtivo] = useState({ id: new Date().getMonth() + 1 });

  useEffect(() => {
    let item = data?.length > 0 ? data[0].meses?.find((e) => e?.id == mesAtivo?.id) : undefined;
    setMesAtivo(item ? item : { id: new Date().getMonth() + 1 });
  }, [data]);

  return (
    <Container>
      <div className="content-os">
        {
          osRejeitada && (
            <div className="alerta-rejeitado">
              <p>Você possui {quantRejeitada} ordem(ns) de serviço(s) rejeitada(s)</p>
            </div>
          )
        }
        <ScrollOS>
          {mesAtivo?.list?.length > 0 && mesAtivo?.list?.map((thisData, i) => (
            <ThisCard
              className={
                linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'
              }
              {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
              key={thisData?.id || i}
              id={thisData?.id || i}
              index={i}
              ativo={linhaAtiva === thisData?.id ? true : false}
              corBackground={thisData?.corStatusAprov}
            >
              <div className="top">
                <div className="content-top">
                  <div className="card-cod">
                    <p className="cod">#{thisData?.id}</p>
                  </div>
                  <div className="card-top">
                    <p className="titulo">{thisData?.titulo}</p>
                    <p className="analista">{thisData?.analista}</p>
                  </div>
                </div>
                <div className="info">
                  <p className="data">{thisData?.data}</p>
                  <p className="projeto">{thisData?.projeto}</p>
                  <p className="cliente">{thisData?.cliente}</p>
                </div>
              </div>
              <div className="content-os">
                <div className="left">
                  <div className="horario">
                    {thisData?.horas?.map((thisHora, a) => (
                      <div className="item-hora">
                        <div className="card-numero">
                          <p className="numero">{a + 1}</p>
                        </div>
                        <div className="card-hora">
                          <p className="hora">{thisHora?.horaInicialMascara} - {thisHora?.horaFinalMascara}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="totalizadores">
                    <p className="desconto">Desconto: {thisData?.desconto}h</p>
                    <p className="translado">Translado: {thisData?.translado}h</p>
                    <div className="card-total">
                      <p className="total">Total: {thisData?.total}h</p>
                    </div>
                  </div>
                </div>
                <div className="right">
                  <div className="status">
                    <p>{thisData?.descricaoStatusAprov}</p>
                    <span class="item-color"></span>
                  </div>
                </div>
              </div>
            </ThisCard>
          ))}
        </ScrollOS>
      </div>
      <ThisCalendar>
        <div className="calendario">
          <Select
            isNumber
            list={{
              list: anos,
              value: 'id',
              label: 'id',
            }}
            name="anoAtivo"
            defaultValue={anoAtivo}
            onChange={e => {
              const v = e.currentTarget.value || 2023;

              setAnoAtivo(v);
            }}
          />
          <div className="meses">
            {data?.length > 0 && data[0].meses?.map((thisData, i) => (
              <div onClick={() => setMesAtivo(thisData)} className={thisData?.id == mesAtivo?.id ? "mes" : "mes-desativo"}>
                <p className="titulo-mes">{thisData?.sigla}</p>
                <p className="ano">{thisData?.ano}</p>
              </div>
            ))}
          </div>
        </div>
      </ThisCalendar>
    </Container>
  );
}

export default CustomBodyContent;
